import React, { useContext, useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { BASE_URL_API } from '../../References/url'
import AuthContext from '../../Store/auth-context'
import styles from './EachCampaigns.module.css'

const EachCampaigns = () => {
    const authCtx = useContext(AuthContext)
    const { campaignIdentifier } = useParams()
    const [campaignStats, setCampaignStats] = useState(null)
    const [loading, setLoading] = useState(false)

    const getBoosterCodesStatistics = async () => {
        setLoading(true)
        try {
            const response = await fetch(BASE_URL_API + "/getBoosterCodesStatistics",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        campaignIdentifier: campaignIdentifier
                    })
                })

            if (!response.ok) {
                console.error("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo.status === "success") {
                    setCampaignStats(respo.response)
                } else {
                    if (respo.message === "token Expired, please login again!") {
                        authCtx.logout()
                    }
                }
                console.log(respo)
            }
        } catch (err) {
            console.error("Fetch error:", err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getBoosterCodesStatistics()
    }, [])

    return (
        <div className={styles.eachCampaignContainer}>
            <h2 className={styles.pageTitle}>Campaign Details</h2>
            <p className={styles.campaignIdentifier}>
                Campaign ID: <span>{campaignIdentifier}</span>
            </p>

            <div className={styles.actionsContainerFull}>
                <div className={styles.actionCard}>
                    <h3>
                        Total Rewards Distributed :
                    </h3>
                    <p>
                        ₹{campaignStats?.totalPointsEarned}
                    </p>
                </div>
            </div>

            <div className={styles.actionsContainer}>
                <Link to={`qr-codes`} className={styles.actionCard}>
                    <div className={styles.cardContent}>
                        <h3>Download QR Codes</h3>
                        <p>Access and download all QR codes for this campaign.</p>
                    </div>
                </Link>

                <Link to={`/points-redeemed`} className={styles.actionCard}>
                    <div className={styles.cardContent}>
                        <h3>View Transactions</h3>
                        <p>See points redeemed and transaction details.</p>
                    </div>
                </Link>
            </div>
        </div>
    )
}

export default EachCampaigns
